module.exports = __webpack_public_path__ + "static/media/coding.e3fcd3e6.png";